import React, { Component, RefObject } from "react";
import { AudioScript } from "./type";
import { LayoutGenerator } from "./layout";
// Components
import GroupShape from "./GroupShape";
import StorylineBar from "./StorylineBar";
import TimeTicks from "./TimeTicks";

type Props = {
  audioScript: AudioScript;
  riskColorMap: Map<string, string>;
  setCurrentVideoTime: (currentTime: number) => void;
};

type State = {
  containerW: number;
  containerH: number;
  containerX: number;
  containerPadding: number[];
};

export default class AudioStoryline extends Component<Props, State> {
  containerDom: RefObject<SVGSVGElement> = React.createRef();
  constructor(props: Props) {
    super(props);
    this.state = {
      containerW: 500,
      containerH: 500,
      containerX: 200,
      containerPadding: [100, 20, 20, 20],
    };
  }

  componentDidMount() {
    const DOM = this.containerDom.current as SVGSVGElement;
    const [
      paddingT,
      paddingL,
      paddingB,
      paddingR,
    ] = this.state.containerPadding;
    // Init container
    this.setState({
      containerW: DOM.clientWidth - paddingL - paddingR,
      containerH: DOM.clientHeight - paddingT - paddingB,
    });
  }

  pickRiskColor(riskType: string) {
    if (this.props.riskColorMap.has(riskType)) {
      return this.props.riskColorMap.get(riskType);
    }
    return "#000";
  }

  getGroupShapeTime(sessionIdx) {
    const { audioScript } = this.props;
    if (audioScript.Story) {
      for (const _character in audioScript.Story.Characters) {
        const segments = audioScript.Story.Characters[_character];
        return segments[sessionIdx].Start;
      }
    }
    return 0;
  }

  render() {
    const { audioScript } = this.props;
    const { containerW, containerH, containerX, containerPadding } = this.state;
    const [paddingT, paddingL, paddingB, paddingR] = containerPadding;
    let StorylineBars = [],
      GroupShapes = [];
    if (audioScript && audioScript.Story) {
      const layoutManager = new LayoutGenerator(
        audioScript,
        containerX,
        paddingT,
        containerW - containerX + paddingL,
        containerH
      );
      const storylines = layoutManager.storylines;
      const characters = layoutManager.characters;
      const charactersRiskNum = layoutManager.charactersRiskNum;
      const riskGroups = layoutManager.riskGroupsList;

      // new
      const riskNumMax =
        Math.max(...charactersRiskNum) === 0
          ? 1
          : Math.max(...charactersRiskNum);
      const barHeight = containerH / characters.length;
      StorylineBars = charactersRiskNum.map((num, idx) => {
        if (num === 0) num = 1;
        const riskType = characters[idx].split("_")[0];
        const riskValue = num / riskNumMax;
        const storylineColor = this.pickRiskColor(riskType);
        return (
          <StorylineBar
            key={`storyline-bar-${characters[idx]}`}
            containerX={containerX}
            barHeight={barHeight}
            barStartY={paddingT + barHeight * idx}
            riskValue={riskValue}
            riskColor={storylineColor}
            character={characters[idx]}
            storyline={storylines[idx]}
          />
        );
      });
      GroupShapes = riskGroups.map((riskGroup, idx) => {
        if (riskGroup.length === 0) return;
        const groupShapeTime = this.getGroupShapeTime(idx);
        return (
          <g
            key={`risk-group-${idx}`}
            onClick={() => {
              this.props.setCurrentVideoTime(groupShapeTime);
            }}
          >
            <GroupShape
              sessionId={idx}
              riskGroup={riskGroup}
              storylines={storylines}
              characters={characters}
            />
          </g>
        );
      });
    }
    return (
      <svg
        className="audio-storyline"
        style={{ width: "100%", height: "100%", background: "#fff" }}
        ref={this.containerDom}
      >
        <TimeTicks
          containerX={containerX}
          width={containerW - containerX + paddingL}
          height={paddingT}
        />
        {StorylineBars}
        {GroupShapes}
      </svg>
    );
  }
}
